import { observer } from 'mobx-react-lite';
import { Literal, IndentedBlock, ReportSection, ReportSubSectionHeader, ReportSectionHeader } from '../common-styles';
import { InstrumentationReportingState } from '../InstrumentationReportingState';

export const DomainInstrumentationReport = observer ( ({instrumentationReportingState}: {instrumentationReportingState: InstrumentationReportingState}) => {

	return (<>
		{/* <div>
			Positions
			{JSON.stringify(toJS(instrumentationReportingState.geolocationPositionsObserved))}
		</div> */}
		{ [...instrumentationReportingState.sourceRegDomainToCodeDomainToInstrumentationData.entries()].map( ([sourceRegisteredDomain, codeRegDomainsToListeners]) => {
				return [...codeRegDomainsToListeners.codeDomainToInstrumentationData.values()].map( ({domainOnCallStack, behaviorsObserved}) => {
				const {geolocationPositionsObserved} = behaviorsObserved;
				const {globalKeystrokesRead, eventListenersOnGlobalTags,
					globalPropertiesRead: globalMousePropertiesRead
				} = behaviorsObserved;
				return (
					<ReportSection key={`${domainOnCallStack}\0${sourceRegisteredDomain}`}>
						<ReportSectionHeader><Literal>{domainOnCallStack}&nbsp;⟵&nbsp;{sourceRegisteredDomain}</Literal></ReportSectionHeader>
						<IndentedBlock>
						{ geolocationPositionsObserved == null || geolocationPositionsObserved.length === 0 ? null : (<>
							<ReportSubSectionHeader>Geolocation Positions Retrieved</ReportSubSectionHeader>
							<IndentedBlock>{ geolocationPositionsObserved.map( ({position, eventIndex}) => 
								<div key={eventIndex}>
									<Literal>{position.coords.longitude}</Literal>,&#32;
									<Literal>{position.coords.latitude}</Literal> {position.coords.heading}
								</div>)
							}</IndentedBlock>
						</>)}
						{ globalKeystrokesRead == null ? null : (<>
							<ReportSubSectionHeader>Keystrokes Read from Global Listeners</ReportSubSectionHeader>
							<IndentedBlock>{ Object.entries(globalKeystrokesRead).map( ([event, keyStrokes]) => 
								<div key={event}>
									<Literal>{event}</Literal>:
									<Literal>{
										keyStrokes.find( ({key}) => key.length > 1 ) ? 
											keyStrokes.map( ({key: keyChar}) => `[${keyChar}]` ).join(", ") :
											keyStrokes.map( ({key: keyChar}) => keyChar ).join("")
										}</Literal>
								</div>)
							}</IndentedBlock>
						</>)}
						{ globalMousePropertiesRead == null ? null : (<>
							<ReportSubSectionHeader>Properties Read from Global Mouse Tracking Events</ReportSubSectionHeader>
							<IndentedBlock>{ Object.entries(globalMousePropertiesRead).map( ([event, properties]) => 
								<IndentedBlock key={event}>
									<Literal>{event}</Literal>:
									<IndentedBlock>
									<Literal>{ Object.values(properties).map( ({property, tags}) => (
										<IndentedBlock key={property}>
											{property} ({ Object.values(tags).map( ({tag}) => tag).join(', ')})
										</IndentedBlock>) ) }</Literal>
									</IndentedBlock>
								</IndentedBlock>)
							}</IndentedBlock>
						</>)}
						{ eventListenersOnGlobalTags == null ? null : (<>
							<ReportSubSectionHeader>Global Events Listened To</ReportSubSectionHeader>
							<IndentedBlock>{
								[...eventListenersOnGlobalTags.values()].map( (event) => (
									<div key={event.domEventName}>
										<Literal>{event.domEventName}</Literal> ({ [...event.tags.values()].map( ({tag}) => tag).join(', ') })
									</div>)
								)
							}</IndentedBlock>	
						</>)}
						</IndentedBlock>
					</ReportSection>
				);
			})
		}).flat()}
	</>)
});
